<template>
  <div id="app" class="full-height">
    <ActionBar v-if="user" />

    <transition mode="out-in">
      <Grid :gtc="user ? 'auto 1fr' : '1fr'" class="full-height">
        <Sidebar v-if="user && settingsFetched" />
        <Grid :gtr="isStagingEnvironment ? 'auto 1fr' : '1fr'" class="page-wrapper">
          <div v-if="isStagingEnvironment" class="staging-environment text-capitalize">Staging Mode</div>
          <router-view :key="rerender" @rerender="rerender++" />
        </Grid>
      </Grid>
    </transition>

    <QInnerLoading :showing="user && loader">
      <QSpinnerCube color="graph-undecided" size="3.5rem" />
    </QInnerLoading>
  </div>
</template>

<script>
import { newDeployment } from './mixins/new-deployment'
// Libraries
import { mapState } from 'vuex'
// Components
import Sidebar from '@/components/sidebar/Sidebar'
import ActionBar from '@/reusable/ActionBar/ActionBar'

export default {
  components: {
    ActionBar,
    Sidebar
  },

  mixins: [newDeployment],

  data: () => ({
    rerender: 1
  }),

  computed: {
    ...mapState({
      user: state => state.user,
      settingsFetched: state => state.settingsFetched,
      loader: state => state.loader
    }),

    isStagingEnvironment() {
      return process.env.VUE_APP_MODE === 'staging'
    }
  }
}
</script>

<style lang="scss">
*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body,
#app {
  height: 100%;
}

body {
  font-family: 'Barlow', sans-serif;
  font-weight: 300;
  background: var(--r-white-2) !important;
  scroll-behavior: smooth;
  overflow: hidden !important;
}

/* Custom global styles */
.q-toggle.disabled {
  .q-toggle__track {
    opacity: 1;
    background: #dadada;
  }
  .q-toggle__thumb:after {
    background: #dadada;
    box-shadow: none;
  }
}

.overflow-auto::-webkit-scrollbar-thumb {
  background: var(--r-secondary-1) !important;
}

.q-editor {
  .q-editor__content {
    color: var(--r-secondary-1);
  }

  .q-editor__toolbars-container {
    padding: var(--r-space-xs);

    .q-btn-item {
      color: var(--r-secondary-1);

      &.text-primary-1 {
        color: var(--r-primary-1);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

#app {
  .page-wrapper {
    position: relative;
    isolation: isolate;

    .staging-environment {
      background: yellow;
      text-align: center;
      font-size: 0.8rem;
      height: 15px;
      z-index: 999;
      font-weight: bold;
      line-height: 15px;
    }
  }
}
</style>
